import { render, staticRenderFns } from "./FeedContentButtonsContainer.vue?vue&type=template&id=247ac038&scoped=true&"
import script from "./FeedContentButtonsContainer.vue?vue&type=script&lang=ts&"
export * from "./FeedContentButtonsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FeedContentButtonsContainer.vue?vue&type=style&index=0&id=247ac038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247ac038",
  null
  
)

export default component.exports